import type { SYSFormField } from "../../../../../../_ovlclient/src/library/forms/fieldapi"

export type PortalBPFilter = {
  CardCode: string
}

export let BPFilterFields: {
  [key in keyof PortalBPFilter]: SYSFormField
} = {
  CardCode: {
    type: "text",
    list: {
      displayField: "CardName",
      valueField: "CardCode",
      displayValueField: true,
      acceptOnlyListValues: true,
      serverEndpoint: "data/lookups/cardcode",
      onlyRefreshFromServerIfOlderThanMs: 10000,
      tryGetLookupFromServerInFormInitIfNotFound: true,
    },
    schema: { nullable: false },
    ui: {
      infoValueTranslationCode: "QUTOfferingOfferingAdminSelectCustomer",
      noLabel: true,
      selectIfFocused: true,
    },
  },
}
